import { CheckBox, CustomVideoPlayer } from '@room-match/shared-ui-components';
import React from 'react';
import IMedia from 'shared/interfaces/IMedia';
import { VideoItemCont } from './VideoBin.styles';
import { CONFIG } from 'shared/config';

interface Props {
  item: IMedia;
  checked: boolean;
  handleSelect: (m: IMedia) => void;
}

const VideoBinItem: React.FC<Props> = ({ item, checked, handleSelect }) => {
  const checkClick = () => {
    handleSelect(item);
  };
  return (
    <VideoItemCont>
      <div style={{ position: 'absolute', top: -5, left: -5, zIndex: 10 }}>
        <CheckBox checked={checked} onClick={checkClick} />
      </div>
      <div style={{ flex: 1, height: '100%', borderRadius: 10, boxShadow: '0 0 10px 0 #2d343e' }}>
        <CustomVideoPlayer
          isSmall
          classes={{ root: 'profile-video-item', videoPlayer: '', icon: '' }}
          url={`${CONFIG.UPLOAD_API_URL}/media/${item.id}`}
        />
      </div>
    </VideoItemCont>
  );
};

export default VideoBinItem;
